import { FormattedEncounter } from "~/features/dashboard/pages/encounters/types";
import { PatientDetailsTabs } from "./patient-details-tabs";
import { PatientSummary } from "./patient-summary";

interface PatientDetailsConditionalProps {
  encounter: FormattedEncounter;
  onOpenChange?: (open: boolean) => void;
  program?: string;
  showTask?: boolean;
  type?: string;
  onStatusChange?: (status: string, tag: string) => void;
}

export const PatientDetailsConditional = ({ encounter, onOpenChange, program, showTask, type, onStatusChange }: PatientDetailsConditionalProps) => {
  // Use PatientSummary for urgent-care, PatientDetailsTabs for weightloss
  if (program === "urgent-care") {
    return <PatientSummary encounter={encounter} onOpenChange={onOpenChange} showTask={showTask} type={type} onStatusChange={onStatusChange} />;
  }
  
  // Default to PatientDetailsTabs for weightloss or any other program
  return <PatientDetailsTabs encounter={encounter} onOpenChange={onOpenChange} />;
}; 